import React from 'react';
import { IIconProps } from './utils';

export const Play = ({
  fill = 'currentColor', height = 16, width = 16, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 16 16" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <rect fill="none" height={height} width={width} />
    <path
      d="M3.33333 12.3624V3.63756C3.33333 2.34409 4.75632 1.56288 5.83832 2.26233L12.5867 6.62476C13.5822 7.26832 13.5822 8.73168 12.5867 9.37523L5.83832 13.7377C4.75632 14.4371 3.33333 13.6559 3.33333 12.3624Z"
      fill={fill}
    />
  </svg>
);
